import React, { memo, useEffect } from "react";
import { validators, formats } from "investira.sdk";
import { Stack, Divider, Typography } from "investira.react.components";
import ConsultaProvider from "../../../../contexts/ConsultaContext";
import useKickBack from "../../../../hooks/useKickBack";
import withMessage from "../../../../hoc/withMessage";
import PlanoPosicao from "../PlanoPosicao";
import DetalhesErrorMessage from "../DetalhesErrorMessage";
import Highlights from "./Highlights";
import Analise from "./Analise";
import AtivoTipoSection from "./AtivoTipoSection";
import Detalhes from "./Detalhes";

const ConsultaVar = memo((props) => {
  const { data } = props;
  const kick = useKickBack();

  const ativosFiltered = (
    ativos = [],
    filtrarComErro = false,
    atributoErro = "erros"
  ) => {
    if (!Array.isArray(ativos)) return [];

    return ativos.filter((ativo) =>
      filtrarComErro
        ? ativo.hasOwnProperty(atributoErro)
        : !ativo.hasOwnProperty(atributoErro)
    );
  };

  useEffect(() => {
    kick && props.onMessage("Entidade alterada");
  }, [kick]);

  if (validators.isEmpty(data)) {
    return null;
  }

  const xAtivos = ativosFiltered(data.response.detalhe, false);
  const xAtivosError = ativosFiltered(data.response.detalhe, true);
  const xAtivosErrorSize = xAtivosError.length;
  const hasError = xAtivosErrorSize > 0;

  console.log(xAtivos);

  return (
    <ConsultaProvider>
      <Stack spacing={2}>
        <PlanoPosicao
          beta={false}
          created={data.request?.data}
          carteira={data.request_metadata?.carteira}
        />
        <Divider />
        <DetalhesErrorMessage show={hasError} ativosSize={xAtivosErrorSize} />
        <Stack sx={{ gap: 2 }} component="section">
          <Stack
            sx={{
              flex: { xs: 1, sm: 1, md: 4, lg: 5, xl: 4 },
              minHeight: 0,
            }}
          >
            <Highlights data={data} />
          </Stack>
          <Stack>
            <Analise data={data} />
          </Stack>
          <Stack>
            <AtivoTipoSection data={data} />
          </Stack>
          <Stack>
            <Detalhes
              label={"Risco por Ativo (Mensal com nível de confiança em 95%)"}
              data={data}
            />
          </Stack>
        </Stack>
      </Stack>
    </ConsultaProvider>
  );
});

export default withMessage(ConsultaVar);
